import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDNENXTXthCXUmloOk-O-HQZMpQWFo54Ak",
  authDomain: "cdm-grid.firebaseapp.com",
  databaseURL: "https://cdm-grid-default-rtdb.firebaseio.com",
  projectId: "cdm-grid",
  storageBucket: "cdm-grid.firebasestorage.app",
  messagingSenderId: "243638786151",
  appId: "1:243638786151:web:1c605636d5cb376be95cc2"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);  // ADD THIS LINE